export default "__VITE_ASSET__Btm5SlpA__"